// Copyright (c) 2025-2026 One Great World LLC. All rights reserved.

import './SlideStyles.css'

function WindowOrganizerSlide() {
  return (
    <div className="slide-content feature-slide">
      <div className="feature-demo">
        <div className="feature-highlights">
          <div className="highlight">Pin window on top: <kbd>Ctrl+Win+Alt+P</kbd></div>
          <div className="highlight">Adjust opacity: <kbd>Ctrl+Win+Alt+S</kbd></div>
          <div className="highlight">Show in Explorer: <kbd>Ctrl+Win+Alt+E</kbd></div>
          <div className="highlight">No mouse required</div>
        </div>
      </div>

      <div className="feature-header">
        <div className="feature-category">Window+</div>
        <h2 className="slide-title">Pin, dock, control transparency of any window or app</h2>
        <p className="slide-text">
          Pin any window always-on-top, dock it left or right, set and remember window transparency, and jump
          straight to a window's file location in Explorer.
        </p>
      </div>
    </div>
  )
}

export default WindowOrganizerSlide
